import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HighchartsChartModule } from 'highcharts-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { VlDatePipe } from './shared_pipes/vl-date.pipe';
import { HighChartComponent } from './shared_components/high-chart/high-chart.component';
import { DeleteComponent } from './shared_components/delete/delete.component';
import { SpinnerComponent } from './shared_components/spinner/spinner.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { SpinnerConfig } from '../constants/spinner_config.cnst';
import { MaterialModuleMobi } from './material/material.module';
import { HighchartsRendererComponent } from './shared_components/highcharts-renderer/highcharts-renderer.component';
import { ImageCropperComponent } from './shared_components/image-cropper/image-cropper.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import {PositiveIntegerInputDirective} from '../shared/shared_directives/positive-integer-input.directive'
import { TruncatePipe } from './shared_pipes/truncate.pipe';
import { SearchableDropdownDirective } from './shared_directives/searchable-dropdown.directive';
import { SearchableMatMenuComponent } from './shared_components/searchable-mat-menu/searchable-mat-menu.component';
// import { AppPermissionsPipe } from './shared_pipes/appPermissions.pipe';


@NgModule({
  declarations: [
    VlDatePipe,
    TruncatePipe,
    HighChartComponent,
    DeleteComponent,
    SpinnerComponent,
    HighchartsRendererComponent,
    ImageCropperComponent,
    PositiveIntegerInputDirective,
    SearchableDropdownDirective,
    SearchableMatMenuComponent,
    
  ],
  imports: [
    CommonModule,
    HighchartsChartModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModuleMobi,
    NgSelectModule,
    NgxUiLoaderModule.forRoot(SpinnerConfig),
    ImageCropperModule,

  ],
  exports: [
    VlDatePipe,
    TruncatePipe,
    HighChartComponent,
    SpinnerComponent,
    HighchartsRendererComponent,
    ImageCropperComponent,
    PositiveIntegerInputDirective,
    SearchableDropdownDirective,
    SearchableMatMenuComponent,
  ],
  providers: [VlDatePipe]
})
export class SharedModule { }
